"use client";

import { c as _c } from "react/compiler-runtime";
import { ArrowDownWideNarrow } from "lucide-react";
import { useState, useRef, useEffect, useMemo } from "react";
import { SORT_BY_OPTIONS, SORT_BY_OPTIONS_MAPPING } from "@/constants/filter";
import SortDropdown from "@/components/filter-panel/sort/dropdown";
import { useSearchParams } from "next/navigation";
const SortComponent = t0 => {
  const $ = _c(26);
  const {
    searchParams: searchParamsProp
  } = t0;
  const nextSearchParams = useSearchParams();
  let params;
  if ($[0] !== searchParamsProp) {
    params = new URLSearchParams();
    if (searchParamsProp) {
      Object.entries(searchParamsProp).forEach(t1 => {
        const [key, value] = t1;
        if (value !== undefined) {
          const stringValue = Array.isArray(value) ? value[0] : value;
          if (stringValue !== undefined) {
            params.set(key, stringValue);
          }
        }
      });
    }
    $[0] = searchParamsProp;
    $[1] = params;
  } else {
    params = $[1];
  }
  const searchParams = params;
  let t1;
  bb0: {
    if (searchParamsProp) {
      let t2;
      if ($[2] !== searchParams) {
        t2 = searchParams.get("sort_by") || "";
        $[2] = searchParams;
        $[3] = t2;
      } else {
        t2 = $[3];
      }
      t1 = t2;
      break bb0;
    }
    let t2;
    if ($[4] !== nextSearchParams) {
      t2 = nextSearchParams.get("sort_by") || "";
      $[4] = nextSearchParams;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    t1 = t2;
  }
  const selectedSort = t1;
  const [sortdropdown, setSortdropdown] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState("left");
  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setSortdropdown(false);
    };
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleSortChange = t2;
  let t3;
  if ($[7] !== sortdropdown) {
    t3 = () => {
      const newDropdownState = !sortdropdown;
      setSortdropdown(newDropdownState);
      if (newDropdownState && buttonRef.current) {
        const buttonRect = buttonRef.current.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        if (buttonRect.left + 200 > viewportWidth) {
          setDropdownPosition("right");
        } else {
          setDropdownPosition("left");
        }
      }
    };
    $[7] = sortdropdown;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleDropdownToggle = t3;
  let t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const handleClickOutside = event => {
        if (buttonRef.current && !buttonRef.current.contains(event.target as Node) && dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
          setSortdropdown(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    };
    t5 = [];
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  useEffect(t4, t5);
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ArrowDownWideNarrow className="w-[18px] h-[18px] text-[#037A6A]" />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = selectedSort ? " : " : "";
  const t8 = SORT_BY_OPTIONS_MAPPING[selectedSort as keyof typeof SORT_BY_OPTIONS_MAPPING]?.label;
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = <span className="text-lg font-outfit text-[#5A5A5A] font-light">Sort by{" "}<span className="font-normal text-[#434343]">{t7}{t8}</span></span>;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== handleDropdownToggle || $[16] !== t9) {
    t10 = <button ref={buttonRef} className="lg:flex items-center gap-2 border-[1.5px] border-[#037A6A] p-2 rounded-lg hidden h-12" onClick={handleDropdownToggle}>{t6}{t9}</button>;
    $[15] = handleDropdownToggle;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== dropdownPosition || $[19] !== searchParamsProp || $[20] !== selectedSort || $[21] !== sortdropdown) {
    t11 = sortdropdown && <div ref={dropdownRef} className={`absolute z-50 mt-2 max-lg:top-0 ${dropdownPosition === "right" ? "right-0" : "left-0"}`}><SortDropdown options={SORT_BY_OPTIONS} selectedOption={selectedSort} onOptionChange={handleSortChange} searchParams={searchParamsProp} /></div>;
    $[18] = dropdownPosition;
    $[19] = searchParamsProp;
    $[20] = selectedSort;
    $[21] = sortdropdown;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11) {
    t12 = <div className="relative">{t10}{t11}</div>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
};
export default SortComponent;